module.exports = __webpack_public_path__ + "media/images/fantasy_logo--dark-313fcf13cca1bebae198b5ffc56fed2c.svg";